import React from 'react';
import { ArrowRight } from 'lucide-react';
export function ClosingCTASection() {
  return <section className="py-20 bg-brand-yellow" data-id="element-357">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-358">
        <h2 className="text-3xl md:text-5xl font-bold text-brand-dark mb-6" data-id="element-359">
          Built for Contractors Who Hate Wasted Time
        </h2>
        <p className="text-xl text-gray-800 mb-10 leading-relaxed" data-id="element-360">
          Precision Pro Sprayers are designed to eliminate unnecessary steps,
          reduce exposure, and make spraying faster and safer in tight spaces.
        </p>
        <a href="#kits" className="inline-flex items-center justify-center rounded-md font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 uppercase tracking-wide bg-brand-dark text-white hover:bg-gray-800 focus:ring-brand-dark h-14 px-8 text-lg" data-id="element-361">
          Shop Sprayers
          <ArrowRight className="ml-2 h-5 w-5" data-id="element-362" />
        </a>
      </div>
    </section>;
}